export const version = '0.1'
export const host = 'https://saikyo2dome-stg.web.app'
export const newDoc = {
  news: {
    paragraphs: []
  },
  'en-news': {
    paragraphs: []
  },
  onair: {
    text: '',
    details: []
  },
  'en-onair': {
    text: '',
    details: []
  },
  caststaff: {
    paragraphs: [],
    images: [],
    details: []
  },
  'en-caststaff': {
    paragraphs: [],
    images: [],
    details: []
  },
  story: {
    text: '',
    images: []
  },
  'en-story': {
    text: '',
    images: []
  },
  character: {
    text: '',
    thumbnail: '',
    images: [],
    details: [
      {
        name: 'CV',
        content: ''
      },
      {
        name: '顔画像枚数',
        content: '0'
      }
    ],
    tags: []
  },
  'en-character': {
    text: '',
    thumbnail: '',
    images: [],
    details: [
      {
        name: 'CV',
        content: ''
      },
      {
        name: '顔画像枚数',
        content: '0'
      }
    ],
    tags: []
  },
  movie: {
    thumbnail: '',
    details: [
      {
        name: 'YouTube動画ID',
        content: ''
      }
    ]
  },
  'en-movie': {
    thumbnail: '',
    details: [
      {
        name: 'YouTube動画ID',
        content: ''
      }
    ]
  },
  special: {
    thumbnail: '',
    paragraphs: [],
    details: []
  },
  'en-special': {
    thumbnail: '',
    paragraphs: [],
    details: []
  },
  goods: {
    thumbnail: '',
    images: [],
    text: '',
    details: [
      {
        name: '価格',
        content: ''
      },
      {
        name: '発売日',
        content: ''
      },
      {
        name: '発売元',
        content: ''
      },
      {
        name: 'サイズ',
        content: ''
      },
      {
        name: '素材',
        content: ''
      },
      {
        name: 'URL',
        content: ''
      }
    ]
  },
  'en-goods': {
    thumbnail: '',
    images: [],
    text: '',
    details: [
      {
        name: '価格',
        content: ''
      },
      {
        name: '発売日',
        content: ''
      },
      {
        name: '発売元',
        content: ''
      },
      {
        name: 'サイズ',
        content: ''
      },
      {
        name: '素材',
        content: ''
      },
      {
        name: 'URL',
        content: ''
      }
    ]
  },
  bluray: {
    paragraphs: [],
    images: [],
    details: [
    ]
  },
  'en-bluray': {
    paragraphs: [],
    images: [],
    details: [
    ]
  },
  help: {
    thumbnail: '',
    paragraphs: [],
    details: []
  }
}

export const dateObjectItems = [
  'publication_date',
  'update_date',
  'created',
  'modified'
]

export const maxSize = 1024 ** 2 * 1

export const itemNames = {
  created_by: '作成者',
  created: '作成時間',
  modified_by: '最終更新者',
  modified: '最終更新時間',
  publication_date: '公開時間',
  update_date: '更新時間',
  title: 'タイトル',
  id: 'ID',
  description: '要約',
  text: '本文',
  thumbnail: 'サムネイル',
  images: '画像',
  attributes: '属性',
  details: '詳細',
  file_size: 'ファイルサイズ',
  tags: 'タグ'
}

export const sysInfoItems = {
  created: true,
  created_by: true,
  modified: true,
  modified_by: true
}

export const commonItems = {
  title: true,
  publication_date: true
}

export const ext2mime = {
  json: 'application/json',
  pdf: 'application/pdf',
  png: 'image/png',
  gif: 'image/gif',
  jpg: 'image/jpeg',
  jpeg: 'image/jpeg',
  svg: 'image/svg+xml'
}
